<template>
  <v-data-table
    item-key="_id"
    :headers="headers"

    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:item.actions="{ item }">
      <v-btn small icon color="primary" @click="() => $emit('click:edit', item)">
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>

      <v-btn small icon color="error" @click="() => $emit('click:delete', item)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <template v-slot:item.annualFee="{ item }">
      {{ formatPercentage(getTrueValue(item.annualFee)) }}
    </template>

    <template v-slot:item.minimumMonthlyValue="{ item }">
      {{ formatMoney(getTrueValue(item.minimumMonthlyValue)) }}
    </template>

    <template v-slot:item.startDate="{ item }">
      {{ formatDate(item.startDate) }}
    </template>

    <template v-slot:item.endDate="{ item }">
      {{ formatDate(item.endDate) }}
    </template>
  </v-data-table>
</template>

<script>
import { formatMoney, formatDate, formatPercentage } from '@/utils/format-utils';

export default {
  name: 'AdmFeeTable',

  inheritAttrs: false,

  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    rawHeaders: [
      {
        value: 'actions',
        text: 'Ações',
        sortable: false,
        groupable: false,
        width: '98px',
      },

      {
        value: 'type',
        text: 'Tipo',
      },

      {
        value: 'annualFee',
        text: 'Taxa',
      },

      {
        value: 'minimumMonthlyValue',
        text: 'Mínimo Mensal',
      },

      {
        value: 'settlementDays',
        text: 'Dias de Liquidação',
      },

      {
        value: 'startDate',
        text: 'Data Inicial',
      },

      {
        value: 'endDate',
        text: 'Data Final',
      },
    ],
  }),

  computed: {
    headers: (vm) => (vm.readonly
      ? vm.rawHeaders.filter((item) => item.value !== 'actions')
      : vm.rawHeaders
    ),
  },

  methods: {
    formatMoney,
    formatDate,
    formatPercentage,

    getTrueValue(field) {
      return field?.$numberDecimal ?? field;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  th {
    white-space: nowrap;
  }
}
</style>
